import { render, staticRenderFns } from "./CheckData.vue?vue&type=template&id=b9dd153a&"
import script from "./CheckData.vue?vue&type=script&lang=js&"
export * from "./CheckData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports